define((require) => {
    "use strict";

    var Backbone     = require("backbone"),
        ProjectAsset = require("ui/editor/project/ProjectAsset");

    /**
     * A collection of project assets.
     *
     * @see ProjectAsset
     *
     * @class ProjectAssetCollection
     */
    return Backbone.Collection.extend({

        model: ProjectAsset,

        /**
         * Adds a project asset describing the supplied model to this collection. <p>
         *
         * If <tt>model</tt> cannot be described as an asset, this will be a no-op.
         *
         * @param {*} model The Backbone model to add as an asset to this collection; cannot be falsey.
         * @return {Boolean} True if an asset was added, false otherwise.
         *
         * @see    #removeModel
         * @see    #addResource
         */
        addModel: function(model) {
            var asset = ProjectAsset.asAsset(model);

            if (asset) {
                return this.add(asset);
            }

            return false;
        },

        /**
         * Remove the project asset describing the supplied model from this collection, if contained. <p>
         *
         * If <tt>model</tt> cannot be described as an asset, this will be a no-op.
         *
         * @param {*} model The Backbone model to remove the existing asset from this collection, if any; cannot
         *                  be falsey.
         * @return {Boolean} True if an asset was remove, false otherwise.
         *
         * @see    #addModel
         * @see    #removeResource
         */
        removeModel: function(model) {
            var asset = ProjectAsset.asAsset(model);

            if (asset) {
                return this.remove(asset); // TODO: does this work?
            }

            return false;
        },

        addResource: function(id, type) {
            this.add(new ProjectAsset({resourceId: id, resourceType: type}));
        },

        removeResource: function(id, type) {
            return this.remove(this.findWhere({
                resourceId: id,
                resourceType: type
            }));
        },

        byType: function(type) {
            return this.filter((asset) => {
                return asset.get("resourceType") === type;
            });
        },

        /**
         * Given an image id, check whether it is contained in this collection
         *
         * @param {String} resourceId   The id of an image model
         * @returns {Boolean}   True if it is in the collection, false otherwise
         */
        containsImage: function(resourceId) {
            return this._containsResource(resourceId);
        },

        /**
         * Given an experience id, check whether it is contained in this collection
         *
         * @param {String} resourceId   The id of an experience model
         * @returns {Boolean}   True if it is in the collection, false otherwise
         */
        containsExperience: function(resourceId) {
            return this._containsResource(resourceId);
        },

        /**
         * Given a group id, check whether it is contained in this collection
         *
         * @param {String} resourceId   The id of an group model
         * @returns {Boolean} True if it is in the collection, false otherwise
         */
        containsGroup: function(resourceId) {
            return this._containsResource(resourceId);
        },

        /**
         * Given an channel id, check whether it is contained in this collection
         *
         * @param {String} resourceId   The id of an channel model
         * @returns {Boolean}   True if it is in the collection, false otherwise
         */
        containsChannel: function(resourceId) {
            return this._containsResource(resourceId);
        },

        // Check a resource is contained in the collection
        _containsResource: function(resourceId) {
            return !!this.find((asset) => {
                return asset.get("resourceId") === resourceId;
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/project/ProjectAssetCollection.js